var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"mt-3 w-100 btn__generate",class:['btn__filled', _vm.isDisabled ? 'btn__not_filled' : ''],attrs:{"native-type":"submit","type":"primary","disable":_vm.isDisabled},on:{"click":_vm.emitClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }